export default {
  listAccountPlans: [],
  accountPlan: {
    classe: '',
    codNatureza: '',
    tipo: '',
    ativo: true,
  },
}
